import { DimensionStatus, InsightPriority } from "types/graphql-schema";

export type Status = DimensionStatus;
export type Priority = InsightPriority;

export const statusDot: Record<Status, string> = {
  good: "bg-emerald-500",
  warn: "bg-amber-400",
  alert: "bg-orange-500",
  critical: "bg-red-500",
};

export const statusBadge: Record<Status, string> = {
  good: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  warn: "bg-amber-50 text-amber-700 ring-amber-600/20",
  alert: "bg-orange-50 text-orange-700 ring-orange-600/20",
  critical: "bg-red-50 text-red-700 ring-red-600/20",
};

export const priorityBadge: Record<
  Priority,
  { status: Status; label: string }
> = {
  high: { status: DimensionStatus.Critical, label: "Needs Attention" },
  medium: { status: DimensionStatus.Alert, label: "Monitor" },
  low: { status: DimensionStatus.Warn, label: "Low Priority" },
  positive: { status: DimensionStatus.Good, label: "Doing Well" },
};
